import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/components/breadcrumb.component';
import { SkipLinksComponent } from './shared/components/skip-links/skip-links.component';
import { firstValueFrom } from 'rxjs';
import { GlobalService } from './global/services/gobal.service';
import { getGlobalQuery } from './utils/strapi-querys/gobal-filter';
import qs from 'qs';
import { Global } from './shared/interfaces/cpe-interfaces.index';
import { ViewStateComponent } from './shared/components/view-state/view-state.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    NavbarComponent,
    FooterComponent,
    BreadcrumbComponent,
    SkipLinksComponent,
    ViewStateComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  host: {
    '[attr.inert]': 'displayModal ? "" : null',
    '[attr.aria-hidden]': 'displayModal ? "true" : null'
  }
})
export class AppComponent implements OnInit {
  readonly globalService = inject(GlobalService);
  private readonly router = inject(Router);

  protected readonly loadingTitle = "Cargando datos...";
  protected readonly loadingSubtitle = "Esto puede tardar unos segundos. Estamos preparando los datos.";
  protected readonly errorTitle = "Error al cargar datos";
  protected readonly errorSubtitle = "No se ha podido renderizar el contenido porque faltan la barra de navegación y/o el pie de página.";
  readonly status = signal<'loading' | 'loaded' | 'error'>('loading');
  global = signal<Global | null>(null);
  displayModal = false;

  ngOnInit(): void {
    this.getGlobalQuery();
  }

  async getGlobalQuery() {
    this.status.set('loading');

    try {
      const global = await firstValueFrom(this.globalService.getGlobalByQuery(qs.stringify(getGlobalQuery())));
      this.global.set(global);
      this.status.set('loaded');
    } catch (error) {
      this.status.set('error');
      console.log(error);
    }
  }

  get isHome(): boolean {
    return this.router.url === '/home';
  }
}